import React from 'react';
import Footer from '../../components/Footer/Footer';
import LeftNavBar from '../../components/LeftNavBar/LeftNavBar';
import NavHeader from '../../components/NavHeader/NavHeader';
import AccountBranding from '../AccountBranding/AccountBranding';
import { Routes, Route } from 'react-router-dom';
import WeekendAndHolidays from '../WeekendAndHolidays/WeekendAndHolidays';
import EvaluationPeriod from '../EvaluationPeriod/EvaluationPeriod';
import LeaveWfh from '../Leave/LeaveWfh';
import Announcement from '../Announcement/Announcement';
import TeamMood from '../TeamMood/TeamMood';
import TeamMoodCategory from '../TeamMoodCategory/TeamMoodCategory';
import Departments from '../Departments/Departments';
import Goals from '../Goals/Goals';
import OffboardingTemplates from '../OffBoardingTemplates/OffboardingTemplates';
import OffboardingTask from '../../components/OffboardingTasks/OffboardingTask';
import RecruitmentMessage from '../RecruitmentMessage/RecruitmentMessage';
import QuestionFresher from '../QuestionFresher/QuestionFresher';
import Domains from '../../components/Domains/Domains';
import Designation from '../../components/Designation/Designation';
import UserManagement from '../UserManagement/UserManagement';
import CreateGroup from '../CreateGroup/CreateGroup';
import OfferLetter from '../OfferLetter/OfferLetter';
import { QuestionsTechnical, QuestionsAptitude, QuestionsProgramming } from '../QuestionFresher/QuestionsTechnical';

function Admin() {
    return (
        <div className="container-fluid ">
            <div className="row ">
                <NavHeader />
                <LeftNavBar />
                <Routes>
                    <Route path="/accountbranding" element={<AccountBranding />} />
                    <Route path="/weekendandholidays" element={<WeekendAndHolidays />} />
                    <Route path="/evaluationperiod" element={<EvaluationPeriod />} />
                    <Route path="/leave" element={<LeaveWfh />} />
                    <Route path="/announcements" element={<Announcement />} />
                    <Route path="/teammood" element={<TeamMood />} />
                    <Route path="/category" element={<TeamMoodCategory />} />
                    <Route path="/departments" element={<Departments />} />
                    <Route path="/goals" element={<Goals />} />
                    <Route path="/offboarding" element={<OffboardingTemplates />} />
                    <Route path="/offboarding/:tid" element={<OffboardingTask />} />
                    <Route path="recuritementmessage" element={<RecruitmentMessage />} />
                    <Route path="fresherquestions" element={<QuestionFresher />} />
                    <Route path="fresherquestionstechnical" element={<QuestionsTechnical />} />
                    <Route path="fresherquestionsaptitude" element={<QuestionsAptitude />} />
                    <Route path="fresherquestionsprogramming" element={<QuestionsProgramming />} />
                    <Route path="/experiencequestions" element={<Domains />} />
                    <Route path="/experiencequestions/:dId" element={<Designation />} />
                    <Route path="/experiencequestions/:dId/eq/:rId" element={<QuestionFresher />} />
                    <Route path="/usermanagement" element={<UserManagement />} />
                    <Route path="/Groups" element={<CreateGroup />} />
                    <Route path="/recuritementofferletter" element={<OfferLetter />} />
                </Routes>
                <Footer />
            </div>
        </div>
    );
}

export default Admin;
